import { classToPlain, plainToClass } from 'class-transformer';
import { CardSuccessfulPaymentResponseModel, PaymentMethodTypes, PaypalSuccessfulPaymentResponseModel, PaymentTypes, PaymentDetailsModel } from 'models/Payment';

const PAYMENT_RESULT_KEY = 'paymentRes';

export const MAX_DECIMAL_PLACES = 4;

export class PaymentHelper {
    public isCardRelatedPaymentType(paymentType: PaymentTypes): boolean {
        return paymentType === PaymentTypes.Card
            || paymentType === PaymentTypes.Cash
            || paymentType === PaymentTypes.Chip;
    }

    public isCreditRelatedPaymentType(paymentType: PaymentTypes): boolean {
        return paymentType === PaymentTypes.IFC;
    }

    public getSuccessfulPaymentResult(): CardSuccessfulPaymentResponseModel | PaypalSuccessfulPaymentResponseModel | null {
        let paymentResult = localStorage.getItem(PAYMENT_RESULT_KEY);

        if (paymentResult) {
            paymentResult = JSON.parse(paymentResult);

            if ((paymentResult as any).paymentMethodType === PaymentMethodTypes.Card) {
                return plainToClass(CardSuccessfulPaymentResponseModel, paymentResult);
            }

            return plainToClass(PaypalSuccessfulPaymentResponseModel, paymentResult);
        }

        return null;
    }

    public saveSuccessfulPaymentResult(paymentResult: CardSuccessfulPaymentResponseModel | PaypalSuccessfulPaymentResponseModel): void {
        localStorage.setItem(PAYMENT_RESULT_KEY, JSON.stringify(classToPlain(paymentResult)));
    }

    public removeSuccessfulPaymentResult(): void {
        localStorage.removeItem(PAYMENT_RESULT_KEY);
    }

    public isCreditPaymentWithoutDeposit(paymentDetails: PaymentDetailsModel): boolean {
        return this.isCreditRelatedPaymentType(paymentDetails.paymentType) && paymentDetails.ifcDeposit === 0;
    }

    public getDeposit(paymentDetails: PaymentDetailsModel): number {
        return this.isCreditRelatedPaymentType(paymentDetails.paymentType)
            ? paymentDetails.ifcDeposit
            : paymentDetails.cashCardDeposit;
    }

    public isSuccessfulPaymentResultCode(resultCode: string): boolean {
        return resultCode === 'Authorised';
    }
}

export const paymentHelper = new PaymentHelper();